import React       from 'react';
import queryString from 'query-string';

import utils     from '../../../../../../utils';
import Context   from '../../../../../../context';
import Cookies   from 'js-cookie';
import constants from '../../../../../../values/constants';

import { IOnSearchUser          } from '../../../../../../types/common.interface';
import { useTranslation         } from 'react-i18next';
import { SearchDropDownWithBase } from '../../../../../../components';
import {TRANSACTION_BASE_SEARCH_2} from "../../../../../../values/dropdownBaseSearch";

interface iBaseUrl { title: string, value: string }
interface iOnSearch { searchedValue: string; base: { title: string; value: string; }}

const DriverTransactionSearch: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const userType: string = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const { requestParentTransaction, setRequestParentTransaction } = React.useContext(Context.ParentTransactionScreen);
  const [defaultSearch, setDefaultSearch] = React.useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );

  const { t } = useTranslation();

  let baseSearch: Array<iBaseUrl> = TRANSACTION_BASE_SEARCH_2;

  baseSearch = baseSearch.map((item: iBaseUrl): iBaseUrl => ({...item, title: t(item?.title),}));

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSearch(event: IOnSearchUser): boolean {
    setRequestParentTransaction!({
      ...requestParentTransaction,
      search2: {
        path: 'PASSENGER',
        base: event?.base?.value,
        value: event?.searchedValue
      }
    });
    return false;
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <SearchDropDownWithBase
      size="medium-sd"
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      onChangeSearch={(event: iOnSearch): void => {onSearch(event); setDefaultSearch(event.searchedValue)}}
      baseSearchItems={baseSearch}
      defaultBaseSearch={baseSearch[0]}
    />
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default DriverTransactionSearch;
